import React, { useEffect, useRef } from 'react';
import './Footer.css';

const Footer = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    // Initialize Google Maps iframe with user's custom adjustments
    const initializeGoogleMaps = () => {
      if (!mapRef.current) return;

      // Create Google Maps iframe with the user's custom adjustments
      const iframe = document.createElement('iframe');
      iframe.src = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.1234567890123!2d90.4198631!3d23.8164334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDQ4JzU5LjIiTiA5MMKwMjUnNTEuMSJF!5e0!3m2!1sen!2sbd!4v1234567890123";
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.frameBorder = '0';
      iframe.style.border = '0';
      iframe.allowFullScreen = true;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.title = "Edugration Location";
      
      // Clear the loading content and add the iframe
      mapRef.current.innerHTML = '';
      mapRef.current.appendChild(iframe);
    };

    // Initialize the Google Maps iframe
    initializeGoogleMaps();

    return () => {
      // Cleanup
      if (mapRef.current) {
        mapRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Left Column */}

          {/* Middle Column */}
          <div className="footer-column contact-info">
            <div className="footer-logo">
              <a href="/"><img src="/brand_logo-edited.png" alt="Edugration Logo" className="logo-image" /></a>
            </div>
            <div className="contact-box">
              <h3>Contact Information</h3>
              <div className="contact-details">
                <p><strong>Address:</strong> House: 51/J, Apt:A8, Road: 4, Block: D, Bashundhara R/A, Dhaka-1229</p>
                <p><strong>Contact:</strong> +880-1711751037</p>
                <p><strong>Email:</strong> info@edugration-bd.com</p>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="footer-column">
            <div className="map-section">
              <div className="map-container" ref={mapRef}>
                <div className="map-loading">
                  <i className="fas fa-map-marked-alt"></i>
                  <p>Loading Map...</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='footer-content'>
          <div className="get-in-touch">
            <h4>Get in touch</h4>
            <div className="social-icons">
              <a href="#" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>

          <div className="keep-in-touch">
            <h3>Keep in Touch with Edugration</h3>
            <div className="email-subscription">
              <input 
                type="email" 
                placeholder="Email Address" 
                className="email-input"
              />
              <button className="subscribe-btn">Subscribe</button>
            </div>
          </div>
        </div> 
        
        <div className="footer-bottom">
          <p>&copy; 2024 Edugration. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
